module.exports = __webpack_public_path__ + "assets/GoldIota2x.d6e2e1c2c6129da3cbcd31ae524c39fe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/packs2x-gold/GoldIota2x.png
// module id = 811
// module chunks = 0